export class RecuperarPassCorreoPeticion{
    codCliente:string;
    codTpoPortal:string;
    docEmpresa:string;
    correoUsuario: string;
}